import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {LoginPageComponent} from './login/login-page.component';
import {AuthGuard} from './guards/auth.guard';
import {AuthService} from './services/auth.service';

@NgModule({
    declarations: [
        LoginPageComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        LoginPageComponent
    ],
    providers: [
        AuthService,
        AuthGuard
    ]
})
export class AuthModule {
}
